import { IEspmPropertyTypeCategoryNode } from "../../zeos-api/contracts/EspmPropertyType";

let taxonomyCategories: IEspmPropertyTypeCategoryNode[] = [];

export function setEspmTaxonomyForValidation(
  categories: IEspmPropertyTypeCategoryNode[]
): void {
  taxonomyCategories = categories ?? [];
}

export function getEspmTaxonomyForValidation(): IEspmPropertyTypeCategoryNode[] {
  return taxonomyCategories;
}

export function findEspmCategoryForValidation(
  categoryId: number | undefined | null
): IEspmPropertyTypeCategoryNode | undefined {
  if (categoryId == null) {
    return undefined;
  }
  return taxonomyCategories.find(
    (c) => c.espmPropertyTypeCategoryId === categoryId
  );
}
